import {createAction, props} from "@ngrx/store";
import {CountryDto} from "@esa/api";


export const getCountries = createAction(
  '[Countries] Get Countries',
)

export const getCountriesSuccess = createAction(
  '[Countries] Get Countries Success',
  props<{ countries : CountryDto[] }>()
)

export const getCountriesError = createAction(
  '[Countries] Get Countries Error',
)
